export default "__VITE_ASSET__CnYEV2bJ__"